import React, { useRef, useState } from "react";
import {
  Box,
  BlockStack,
  InlineStack,
  TextField,
  Button,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import LoadingScreen from "../LoadingScreen";
import JoditEditor from "jodit-react";
import { useMemo } from "react";

export default function CommentComposer({ taskId, onSent }) {
  const [text, setText] = useState("");
  const [images, setImages] = useState([]);
  const [sending, setSending] = useState(false);
  const uploadToS3 = async (file) => {
    const formData = new FormData();
    formData.append("entity_type", "task_manager_comment_attachment");
    formData.append("image", file);

    const res = await axios.post("/s3/save-file", formData);

    return res.data.data.file_key; // 👈 same as your projects
  };
  // const handlePaste = (e) => {
  //   console.log("paste");

  //   const clipboard = e.clipboardData;
  //   if (!clipboard) return;

  //   const newImages = [];

  //   // ✅ FIRST: try clipboard.items (screenshots + browser images)
  //   if (clipboard.items && clipboard.items.length > 0) {
  //     for (const item of clipboard.items) {
  //       if (item.type.startsWith("image/")) {
  //         const file = item.getAsFile();
  //         if (file) {
  //           newImages.push({
  //             file,
  //             preview: URL.createObjectURL(file),
  //           });
  //         }
  //       }
  //     }
  //   }

  //   // ✅ ONLY IF no images found → fallback to clipboard.files
  //   if (
  //     newImages.length === 0 &&
  //     clipboard.files &&
  //     clipboard.files.length > 0
  //   ) {
  //     for (const file of clipboard.files) {
  //       if (file.type.startsWith("image/")) {
  //         newImages.push({
  //           file,
  //           preview: URL.createObjectURL(file),
  //         });
  //       }
  //     }
  //   }

  //   if (newImages.length > 0) {
  //     e.preventDefault();
  //     setImages((prev) => [...prev, ...newImages]);
  //   }
  // };
  const [isImageUploading, setIsImageUploading] = useState(false);

  const handlePaste = async (e) => {
    setIsImageUploading(true);
    const clipboard = e.clipboardData;
    if (!clipboard) return;

    const files = [];

    if (clipboard.items) {
      for (const item of clipboard.items) {
        if (item.type.startsWith("image/")) {
          const file = item.getAsFile();
          if (file) files.push(file);
        }
      }
    }

    if (!files.length) return;

    e.preventDefault();

    for (const file of files) {
      try {
        const preview = URL.createObjectURL(file);

        // ⬆️ show preview immediately
        setImages((prev) => [...prev, { preview, uploading: true }]);

        // ⬇️ upload to S3
        const key = await uploadToS3(file);

        // 🔁 replace temp image with uploaded one
        setImages((prev) =>
          prev.map((img) =>
            img.preview === preview ? { preview, key, uploading: false } : img
          )
        );
        setIsImageUploading(false);
      } catch (err) {
        console.error("Upload failed", err);
      }
    }
  };

  const handleSend = async () => {
    if (!text && !images.length) return;

    setSending(true);

    const formData = new FormData();
    formData.append("content", text);
    // images.forEach((img) => formData.append("images[]", img.file));
    images.forEach((img) => {
      if (img.key) {
        formData.append("images[]", img.key);
      }
    });
    // 🔹 MOCK RESPONSE STRUCTURE
    const res = await axios.post(`/task-manager/${taskId}/comments`, formData);

    onSent();
    setText("");
    setImages([]);
    setSending(false);
  };
  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const editorRef = useRef(null);
  const editorConfig = useMemo(
    () => ({
      readonly: false,
      toolbarAdaptive: false,
      toolbarSticky: false,
      toolbarButtonSize: "middle",
      buttons: ["bold", "italic", "underline", "|", "ul", "ol"],
      removeButtons: ["link", "source", "fullsize"],
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      showStatusbar: false,
      enableDragAndDropFileToEditor: false,
      spellcheck: false,
      askBeforePasteHTML: false,
      placeholder: "",

      // events: {
      //   paste: (e) => {
      //     handlePaste(e);
      //   },
      // },
      extraButtons: [
        // {
        //   name: "customLink",
        //   iconURL:
        //     "https://img.icons8.com/material-outlined/24/000000/link.png",
        //   tooltip: "Insert Custom Link",
        //   exec: (editor) => {
        //     const url = prompt("Enter link URL");
        //     if (url) {
        //       const sel = editor.selection;
        //       if (sel.range) {
        //         editor.execCommand("createLink", false, url);
        //       }
        //     }
        //   },
        // },
        {
          name: "customImage",
          iconURL:
            "https://img.icons8.com/material-outlined/24/000000/image.png", // Custom icon URL
          exec: (editor) => {
            fileInputRef.current.click();
          },
          tooltip: "Insert Image",
        },
      ],
      uploader: {
        insertImageAsBase64URI: false, // Do not insert images as base64
      },
    }),
    []
  );

  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleImageUpload(file);
    }
  };

  const handleImageUpload = async (file) => {
    console.log("aaaaaa");
    const formData = new FormData();
    formData.append("image", file);
    formData.append("entity_type", "task_manager_comment_attachment");

    try {
      const response = await axios.post("s3/save-file", formData);
      const imageUrl = response.data.data.file_url; // URL of the uploaded file
      console.log("imageUrl=", imageUrl);
      insertImageAtCursor(imageUrl);
      // const editorInstance = editor.current;
      setText((prev) => prev + `<img src="${imageUrl}" />`); // setInstructionValue(instructionValue + `<img src=${imageUrl}></img>`);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
  const insertImageAtCursor = (imageUrl) => {
    const editorInstance = editorRef.current?.editor;
    if (!editorInstance) return;

    editorInstance.selection.insertHTML(
      `<img src="${imageUrl}" alt="Image" />`
    );
    const updatedValue = editorInstance.value;
    setText(updatedValue);
  };
  return (
    <Box padding="300" background="bg-surface-secondary">
      <BlockStack gap="200">
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
          accept="image/*"
        />
        <JoditEditor
          value={text}
          ref={editorRef}
          onChange={(newValue) => setText(newValue)}
          config={editorConfig}
          // onPaste={handlePaste}
        />
        {/* <textarea
          value={text}
          placeholder="Write a comment…"
          onChange={(e) => setText(e.target.value)}
          onPaste={handlePaste}
          style={{
            width: "100%",
            minHeight: "90px",
            padding: "10px 12px",
            borderRadius: "6px",
            border: "1px solid #dfe3e8",
            fontSize: "14px",
            fontFamily: "inherit",
            resize: "vertical",
            outline: "none",
          }}
        /> */}

        {/* Image previews */}
        {images.map((img, i) => (
          <div
            key={i}
            style={{
              position: "relative",
              width: "60px",
              height: "60px",
            }}
          >
            {/* ❌ Delete icon */}
            <div
              onClick={() => removeImage(i)}
              style={{
                position: "absolute",
                top: "-6px",
                right: "-6px",
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                background: "grey", // Polaris critical red
                color: "white",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 2,
              }}
              title="Remove image"
            >
              ✕
            </div>

            {/* Image */}
            <img
              src={img.preview}
              alt=""
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "6px",
                objectFit: "cover",
                border: "1px solid #e1e3e5",
              }}
            />
          </div>
        ))}

        <InlineStack align="end">
          <Button
            primary
            loading={sending}
            onClick={handleSend}
            disabled={!text && !images.length}
          >
            Send
          </Button>
        </InlineStack>
      </BlockStack>
      {isImageUploading ? <LoadingScreen /> : null}
    </Box>
  );
}
